module.exports = __webpack_public_path__ + "static/media/steptwoActive.802bd928.png";